import React, { useState, useCallback } from 'react';
import { Container, Row, Col, Form, FormGroup, Label, Button, Spinner } from 'reactstrap';
import { useDropzone } from 'react-dropzone';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { createBanner } from './redux/dispatcher';

export default function AddBanner() {
    const dispatch = useDispatch()
    const [files, setFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(false)

    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach(file => {
            validateAndAddFile(file);
        });
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        files.forEach((file) => {
            const formData = new FormData();
            formData.append('img_path', file)
            dispatch(createBanner(formData, setIsLoading, setFiles))
        });
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: 'image/*',
        multiple: true,
    });

    const validateAndAddFile = (file) => {
        const validImageTypes = ['image/jpeg', 'image/png'];
        const maxSize = 2 * 1024 * 1024; // 2MB

        if (!validImageTypes.includes(file.type)) {
            toast.error('Only image files (jpg, png) are allowed.');
            return;
        }

        if (file.size > maxSize) {
            toast.error('File size must be less than 2MB.');
            return;
        }

        setFiles(prevFiles => [...prevFiles, file]);
    };

    return (
        <Container fluid>
            <h1 style={{ color: 'rgb(14, 61, 13)' }}>Upload Banner (<span className='h3' style={{ color: 'rgb(14, 61, 13)' }}>Upload in 16:9 ratio for best results</span>)</h1>
            <Form className="mt-4" onSubmit={handleSubmit}>
                <Row>
                    <Col>
                        <FormGroup>
                            <div {...getRootProps()} className="dropzone" style={{ border: '2px dashed rgb(14, 61, 13)', padding: '20px', textAlign: 'center', cursor: 'pointer' }}>

                                <input {...getInputProps()} />
                                <p>Drag & Drop to Upload Files </p>
                                <p>OR </p>

                                <Button style={{ color: 'white', backgroundColor: 'rgb(14, 61, 13)' }} className="btn-primary mb-3">
                                    Browse File</Button>
                                <br />
                                {files.length > 0 && (
                                    <div style={{ display: 'inline-block', border: '1px solid green', padding: '10px', borderRadius: '5px' }}>
                                        <span className='mr-4 font-weight-900'>Selected files: </span>
                                        {files.map((file, index) => (
                                            <span key={index} className='mr-4'>{file.name}</span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </FormGroup>
                        {/* <FormGroup>
                            <Label for="fileInput">Or select files to upload:</Label>
                            <input type="file" id="fileInput" name="fileInput" onChange={handleFileChange} multiple />
                        </FormGroup> */}

                    </Col>
                </Row>
                <div className="text-center ">
                    <Button type="submit" style={{ color: 'white', backgroundColor: 'rgb(14, 61, 13)' }} disabled={files.length == 0 || isLoading}>
                        {
                            isLoading ? <Spinner size={'sm'} /> :
                                <>

                                    <i class="fa-solid fa-upload"></i> Upload
                                </>
                        }
                    </Button>
                </div>
            </Form>
        </Container>
    );
}
